import React from 'react';
import { Paper, Grid, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { ReactComponent as QuipLogo } from '../../assets/QuIP_Logo_GmbH_rgb.svg';
import { VoucherCode, Trial } from '../../redux/types';
// import MerckLogo from '../../assets/merck.png';

type Props = {
  voucherDetail: VoucherCode & { trial: Trial };
  children: React.ReactNode;
}

const VoucherSuccess: React.FC<Props> = ({ voucherDetail, children }: Props) => (
  <Paper
    sx={{
      padding: '30px',
      maxWidth: '600px',
      textAlign: 'center',
    }}
  >
    <Typography gutterBottom>
      <FormattedMessage id="voucher.couponCode" />
      :
      {` ${voucherDetail.code}`}
    </Typography>
    {/* <h1 className={classes.heading}>
        PD-L1 International Proficiency Testing
      </h1> */}
    <Typography variant="h4" sx={{ color: 'primary.main' }}>
      {voucherDetail.trial.name}
    </Typography>
    {children}
    <Grid container sx={{ py: '20px' }} alignItems="center">
      <Grid item sm={6} xs={12}>
        {/* <QuipLogo className={classes.quipLogo} /> */}
      </Grid>
      <Grid item sm={6} xs={12}>
        {/* <img alt="MERCK logo" src={MerckLogo} className={classes.merckLogo} /> */}
        <QuipLogo
          style={{
            width: '100px',
            height: 'auto',
            float: 'right',
          }}
        />
      </Grid>
    </Grid>
  </Paper>
);

export default VoucherSuccess;
